// TODO: Default enable an extension demo based on the browser
// TODO: verify URL and provide error messages
import { Link, useLocation } from 'react-router-dom';
import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import logo from '../../sidebar-logo.png';
import screenshot from './screenshot.png';
import applepodcasts from '../../Assets/podcast-apps/icon-applepodcasts.svg';
import breaker from '../../Assets/podcast-apps/icon-breaker.svg';
import castbox from '../../Assets/podcast-apps/icon-castbox.svg';
import googlepodcasts from '../../Assets/podcast-apps/icon-googlepodcasts.svg';
import overcast from '../../Assets/podcast-apps/icon-overcast.svg';
import playerfm from '../../Assets/podcast-apps/icon-playerfm.svg';
import pocketcasts from '../../Assets/podcast-apps/icon-pocketcasts.svg';
import radiopublic from '../../Assets/podcast-apps/icon-radiopublic.svg';
import castro from '../../Assets/podcast-apps/icon-castro.svg';
import podbean from '../../Assets/podcast-apps/icon-podbean.svg';
import downcast from '../../Assets/podcast-apps/downcast.png';
import podcastRepublic from '../../Assets/podcast-apps/podcastRepublic.png';
import podcastAddict from '../../Assets/podcast-apps/podcastAddict.png';
import thePodcastApp from '../../Assets/podcast-apps/the-podcast-app.png';
import spotify from '../../Assets/podcast-apps/Spotify_icon.svg';
import airr from '../../Assets/podcast-apps/airr.svg';
import Chrome from '../../Assets/chrome.svg';
import Safari from '../../Assets/safari.svg';
import Article from './Components/Article';
import FeedSubscribed from "../../Pages/DiscoverNew/Components/FeedSubscribed";
import mixpanel from 'mixpanel-browser';
import BorderColorIcon from '@mui/icons-material/BorderColor';
import YouTubeIcon from '@mui/icons-material/YouTube';
import {
  isAndroid,
  isIOS,
  isEdge,
  isMobile,
  isChrome,
} from 'react-device-detect';
import Player from '../../Components/PlayerNew';
import {
  Apple as AppleIcon,
  Android as AndroidIcon,
} from '@mui/icons-material';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import ForwardToInboxIcon from '@mui/icons-material/ForwardToInbox';
import ContentPasteIcon from '@mui/icons-material/ContentPaste';
import { observer } from 'mobx-react';
import { publish, subscribe, unsubscribe } from '../../PlayerPubSub';
import userStore from '../../Stores/User';
import { isProPlan } from '../../constants/plans';
import { logExperimentView, logConversion } from '../../firebase';
import { CircularProgress } from "@mui/material";
import { getAllFeeds, getLatestFeedArticle } from "../../audiblogsApi";

import './landingA.scss';  // Create a separate stylesheet for variant B
import YoutubeIframe from "./Components/YoutubeIframe";
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import OneGiftLogo from '../../Components/OneGiftLogo';

const ProBadge = observer(() => {
    const isProUser = userStore.user?.subscriptions?.raw_subscriptions?.[0]?.plan?.id 
      ? isProPlan(userStore.user.subscriptions.raw_subscriptions[0].plan.id)
      : false;
    const hasPlan = userStore.user?.subscriptions?.raw_subscriptions?.[0]?.plan?.id;
  
    const [showPopover, setShowPopover] = useState(false);
  
    const badgeStyle = {
      background: isProUser 
        ? 'linear-gradient(135deg, #CB5EEE 0%, #4BE1EC 100%)' 
        : hasPlan 
          ? 'linear-gradient(135deg, #FFB347 0%, #FFCC33 100%)'
          : 'linear-gradient(135deg, #FF6B6B 0%, #FFE66D 100%)',
      padding: '2px 6px',
      borderRadius: '8px',
      fontSize: '11px',
      fontWeight: 'bold',
      position: 'absolute',
      top: isProUser ? '35px' : '0px',
      left: '45px',
      display: 'inline-flex',
      alignItems: 'center',
      height: '16px',
      width: isProUser ? '32px' : hasPlan ? '70px' : '95px',
      justifyContent: 'center',
      cursor: isProUser ? 'default' : 'pointer',
      textDecoration: 'none',
      whiteSpace: 'nowrap',
      color: 'white'
    };
  
    const popoverStyle = {
      position: 'absolute',
      top: '25px',
      left: '45px',
      background: 'rgba(0, 0, 0, 0.9)',
      padding: '8px 12px',
      borderRadius: '8px',
      fontSize: '12px',
      width: '200px',
      color: 'white',
      zIndex: 1000,
      pointerEvents: 'none',
      opacity: showPopover ? 1 : 0,
      transition: 'opacity 0.2s ease-in-out',
      boxShadow: '0 2px 10px rgba(0, 0, 0, 0.2)',
      backdropFilter: 'blur(5px)'
    };
  
    if (!userStore.user) return null;
  
    if (isProUser) {
      return (
        <div style={badgeStyle}>
          PRO
        </div>
      );
    }
  
    if (hasPlan) {
      return (
        <div style={{ position: 'relative' }}>
          <a 
            href={userStore.customerPortalUrl} 
            target="_blank" 
            style={badgeStyle}
            onMouseEnter={() => setShowPopover(true)}
            onMouseLeave={() => setShowPopover(false)}
            onClick={(e) => {
              if (!userStore.customerPortalUrl) {
                e.preventDefault();
              }
            }}
          >
            UPGRADE
          </a>
          <div style={popoverStyle}>
            Upgrade to pro to get premium voices, other languages, and more!
          </div>
        </div>
      );
    }
  
    return (
      <div style={{ position: 'relative' }}>
        <Link 
          to="/onboarding/ChooseVoice" 
          style={badgeStyle}
          onMouseEnter={() => setShowPopover(true)}
          onMouseLeave={() => setShowPopover(false)}
        >
          START TRIAL
        </Link>
        <div style={popoverStyle}>
          Start your 3-day free trial today!
        </div>
      </div>
    );
  });
  
  const LandingA = observer(() => {
    const [deviceDemo, setDeviceDemo] = useState('chrome');
    const [selectedDemo, setSelectedDemo] = useState('');
    const [demoUrl, setDemoUrl] = useState('');
    const desktopVideoRef = useRef(null);
    const mobileVideoRef = useRef(null);
    const imageRef = useRef(null);
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const [vipId, setVipId] = useState(queryParams.get('vip'));
    const [cta, setCta] = useState("Try for Free Now");
    const [lanSupport, setLanSupport] = useState("");
    const supportedLaguages = {
      "af": "Afrikaans",
      "am": "Amharic",
      "ar": "العربية",
      "az": "Azərbaycan dili",
      "bg": "български",
      "bn": "বাংলা",
      "bs": "bosanski",
      "ca": "Català",
      "cs": "čeština",
      "cy": "Cymraeg",
      "da": "Dansk",
      "de": "Deutsch",
      "el": "Ελληνικά",
      "es": "Español",
      "et": "eesti",
      "eu": "euskara",
      "fa": "فارسی",
      "fi": "suomi",
      "fil": "Filipino",
      "fr": "Français",
      "ga": "Gaeilge",
      "gl": "galego",
      "gu": "ગુજરાતી",
      "he": "עברית",
      "hi": "हिन्दी",
      "hr": "hrvatski",
      "hu": "magyar",
      "hy": "հայերեն",
      "id": "Indonesia",
      "is": "íslenska",
      "it": "Italiano",
      "ja": "日本語",
      "jv": "Jawa",
      "ka": "ქართული",
      "kk": "қазақ тілі",
      "km": "ភាសាខ្មែរ",
      "kn": "ಕನ್ನಡ",
      "ko": "한국어",
      "lo": "ລາວ",
      "lt": "lietuvių",
      "lv": "latviešu",
      "mk": "македонски",
      "ml": "മലയാളം",
      "mn": "Монгол хэл",
      "mr": "मराठी",
      "ms": "Bahasa Melayu",
      "mt": "Malti",
      "my": "ဗမာစာ",
      "nb": "Norsk bokmål",
      "ne": "नेपाली",
      "nl": "Nederlands",
      "pl": "polski",
      "ps": "پښتو",
      "pt": "Português",
      "ro": "Română",
      "ru": "Русский",
      "si": "සිංහල",
      "sk": "slovenčina",
      "sl": "slovenščina",
      "so": "Soomaali",
      "sq": "Shqip",
      "sr": "српски",
      "su": "Basa Sunda",
      "sv": "Svenska",
      "sw": "Kiswahili",
      "ta": "தமிழ்",
      "te": "తెలుగ",
      "th": "ไทย",
      "tr": "Türkçe",
      "uk": "українська",
      "ur": "اردو",
      "uz": "Oʻzbekcha",
      "vi": "Tiếng Việt",
      "wuu": "吴语",
      "yue": "粤语",
      "zh": "中文",
      "zu": "isiZulu"
    };
    useEffect(() => {
      if (vipId) {
        mixpanel.people.set_once({
          utm_source: "vip",
          vip_id: vipId,
        });
  
        fetch(`${process.env.REACT_APP_BACKEND_URL}/api/promo/is_vip_code_available/${vipId}`, {
          method: 'GET',
        })
          .then((response) => response.json())
          .then((data) => {
            if (data.is_vip_code_available) {
              userStore.updateVipId(vipId);
              setCta("Claim Lifetime Access")
            }
          })
          .catch((error) => {
            console.error('Error:', error);
          });
      }

      // Set device demo based on platform
      if (isIOS) {
        onClickDemo('iOS');
      } else if (isAndroid) {
        onClickDemo('Android');
      } else {
        onClickDemo('Chrome');
      }
    }, [vipId]);
    const [popularArticles, setPopularArticles] = useState([
      {
        article_id: "https://www.bbc.co.uk/news/articles/cy4m84d2xz2o",
        audio_url: "https://unreal-expire-in-90-days.s3-us-west-2.amazonaws.com/f4dd27f6-d5dd-416b-b229-54b301eeb48c-0.mp3",
        thumbnail_url: "https://ichef.bbci.co.uk/ace/standard/976/cpsprodpb/84ff/live/1f881110-d87c-11ef-ac27-7d96dfc74407.jpg.webp",
        date_added: "2024-08-29T11:19:48.43Z",
        title: "Stargate: Tech giants announce AI plan worth up to $500bn",
        num_characters: 8945,
      },
      {
        article_id: "https://www.bbc.co.uk/news/articles/cy48v1x4dv4o",
        audio_url: "https://unreal-expire-in-90-days.s3-us-west-2.amazonaws.com/3a554731-3e87-4b06-8454-f28d46f6fbba-0.mp3",
        thumbnail_url: "https://ichef.bbci.co.uk/images/ic/320x180/p0kkzpkv.jpg.webp",
        date_added: "2024-09-08T11:12:16.80Z",
        title: "Musk responds to backlash over gesture at Trump rally",
        num_characters: 9391,
      },
      {
        article_id: "https://paulgraham.com/foundermode.html",
        audio_url: "https://unreal-expire-in-90-days.s3-us-west-2.amazonaws.com/38dc82de-2f76-4f67-8aec-a937db43bb79-0.mp3",
        thumbnail_url: "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b2/Y_Combinator_logo.svg/1200px-Y_Combinator_logo.svg.png",
        date_added: "2024-09-02T10:56:49.74Z",
        title: "Paul Graham's: Founder Mode",
        num_characters: 6986,
      },
    ]);
    const history = useHistory();
    const [isFullPlayer, updateIsFullPlayer] = useState(false);
    const [isPlayerEnabled, setIsPlayerEnabled] = useState(false);
  
    const [isPlaying, setIsPlaying] = useState(false);
    const [currentArticle, setCurrentArticle] = useState({
      id: '',
      article_url: '',
      title: '',
      audio_url: '',
    });
  
    const selectArticle = (article) => {
      setCurrentArticle(article);
      setIsPlayerEnabled(true);
  
      setTimeout(
        () =>
          publish(
            isPlaying &&
              currentArticle &&
              currentArticle.article_id === article.article_id
              ? 'pause'
              : 'play'
          ),
        1
      );
    };
  
    useEffect(() => {

      // Set demo based on device
      if (isIOS) {
        onClickDemo('iOS');
      } else if (isAndroid) {
        onClickDemo('Android');
      } else {
        onClickDemo('Chrome');
      }

      // Handle video refs and playback
      if (desktopVideoRef.current && mobileVideoRef.current) {
        desktopVideoRef.current.onended = () => {
          desktopVideoRef.current.pause();
          desktopVideoRef.current.currentTime = desktopVideoRef.current.duration;
          mobileVideoRef.current.play();
        };

        mobileVideoRef.current.onended = () => {
          mobileVideoRef.current.pause();
          mobileVideoRef.current.currentTime = mobileVideoRef.current.duration;
          const videoSrc = desktopVideoRef.current.currentSrc;

          if (videoSrc.includes('1-540p.mp4')) {
            desktopVideoRef.current.poster = desktopVideoRef.current.poster.replace("1-cropped.jpg", "2-cropped.jpg");
            desktopVideoRef.current.src = videoSrc.replace('1-540p.mp4', '2-540p.mp4');
            desktopVideoRef.current.load();
            mobileVideoRef.current.src = mobileVideoRef.current.src.replace("1-cropped.mp4", "2-cropped.mp4");
            mobileVideoRef.current.poster = mobileVideoRef.current.poster.replace("1-cropped.jpg", "2-cropped.jpg");
            mobileVideoRef.current.load();
          } else if (videoSrc.includes('2-540p.mp4')) {
            mobileVideoRef.current.poster = mobileVideoRef.current.poster.replace("2-cropped.jpg", "3-cropped.jpg");
            desktopVideoRef.current.poster = desktopVideoRef.current.poster.replace("2-cropped.jpg", "3-cropped.jpg");
            desktopVideoRef.current.src = videoSrc.replace('2-540p.mp4', '3-540p.mp4');
            mobileVideoRef.current.src = mobileVideoRef.current.src.replace("2-cropped.mp4", "3-cropped.mp4");
            desktopVideoRef.current.load();
            mobileVideoRef.current.load();
          } else {
            mobileVideoRef.current.poster = mobileVideoRef.current.poster.replace("3-cropped.jpg", "1-cropped.jpg");
            desktopVideoRef.current.poster = desktopVideoRef.current.poster.replace("3-cropped.jpg", "1-cropped.jpg");
            desktopVideoRef.current.src = videoSrc.replace('3-540p.mp4', '1-540p.mp4');
            mobileVideoRef.current.src = mobileVideoRef.current.src.replace("3-cropped.mp4", "1-cropped.mp4");
            desktopVideoRef.current.load();
            mobileVideoRef.current.load();
          }

          desktopVideoRef.current.play();
        };
      }

      // Handle language detection
      try {
        const userLanguage = navigator.language;
        const shortCode = userLanguage.split('-')[0].trim();
        mixpanel.people.set_once({
          navigatorLanguageCode: "navigator.language",
          navigatorLanguage: shortCode === "en" ? "English" : supportedLaguages[shortCode],
        });
        setLanSupport(supportedLaguages[shortCode]);
      } catch (e) {
        console.log(e);
      }

      // Handle player state subscriptions
      const setPlaying = () => setIsPlaying(true);
      const setPaused = () => setIsPlaying(false);

      subscribe('playing', setPlaying);
      subscribe('paused', setPaused);

      return () => {
        unsubscribe('playing', setPlaying);
        unsubscribe('paused', setPaused);
      };
    }, [desktopVideoRef, mobileVideoRef]);
  
    const onClickDemo = (selection) => {
      // setSelectedDemo(selection);
      // setDemoUrl(
      //   `https://audiblogs-conversions-new.s3.us-east-1.amazonaws.com/images/2023/${selection}.mp4`
      // );
    };
  
    const PodcastApp = (src, name) => {
      return (
        <div className="podcast-app-icon-container">
          <img className="podcast-app-icon" src={src} alt={`${name} logo`}></img>
          <br /> {name}
          <br />
        </div>
      );
    };
  
    const renderSignUpButton = () => {
      return (
        <div className="cta-div" style={{ position: 'static', width: 'auto' }}>
          <Link
            to="/signin"
            className="cta-button"
            onClick={(e) => {
              mixpanel.track('Click Sign Up (Nav)', {
                placement: isChrome ? 'Chrome' : 'Edge',
                variant: 'A',
                experiment: 'landing_page_test'
              });
              logConversion('sign_up_click', 'A');
            }}
          >
            <div style={{ display: 'flex', justifyContent: 'space-around' }}>
              <div>
                <div>Sign Up</div>
              </div>
            </div>
          </Link>
        </div>
      );
    };
  
    const renderCta = (placement = '') => {
      return (
        <div className="cta-div" style={{ position: 'static' }}>
          <Link
            to="/signin"
            className="cta-button"
            onClick={(e) => {
              mixpanel.track('Click Try For Free', {
                placement: placement,
                variant: 'A',
                experiment: 'landing_page_test'
              });
              logConversion('try_for_free_click', 'A');
            }}
          >
            <div style={{ display: 'flex', justifyContent: 'space-around' }}>
              <div>
                <div>{cta}</div>
              </div>
            </div>
          </Link>
        </div>
      );
    };
  
    const [isMenuOpen, setIsMenuOpen] = useState(false);
  
    const toggleMenu = () => {
      setIsMenuOpen(!isMenuOpen);
    };
  
    const [isYearly, setIsYearly] = useState(false);
  
    const handleVoiceChange = async (articleId, newVoice) => {
      // Find the article
      const article = popularArticles.find(a => a.article_id === articleId);
      if (!article) return;

      try {
        // Call API to reprocess with new voice
        const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/reprocess`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            article_id: articleId,
            voice: newVoice
          })
        });

        if (response.ok) {
          const updatedArticle = await response.json();
          
          // Update the articles list with new audio URL
          setPopularArticles(articles => 
            articles.map(a => 
              a.article_id === articleId 
                ? { ...a, voice: newVoice, audio_url: updatedArticle.audio_url }
                : a
            )
          );

          // If this was the currently playing article, update it
          if (currentArticle?.article_id === articleId) {
            setCurrentArticle(prev => ({
              ...prev,
              voice: newVoice,
              audio_url: updatedArticle.audio_url
            }));
          }

          // Track voice change in analytics
          mixpanel.track('Change Article Voice', {
            article_id: articleId,
            new_voice: newVoice,
            old_voice: article.voice || 'Matthew'
          });
        }
      } catch (error) {
        console.error('Error changing voice:', error);
        // You might want to show an error notification here
      }
    };
  
    const [allFeeds, setAllFeeds] = useState([]);
    const [displayedFeeds, setDisplayedFeeds] = useState([]);
    const [feedsLoading, setFeedsLoading] = useState(true);
    const [hasMore, setHasMore] = useState(true);
    const [page, setPage] = useState(0);
    const observer = useRef();
    const loadingRef = useRef();
    const FEEDS_PER_PAGE = 9;

    const loadMoreFeeds = useCallback(() => {
      if (!feedsLoading && hasMore) {
        const start = page * FEEDS_PER_PAGE;
        const end = start + FEEDS_PER_PAGE;
        const newFeeds = allFeeds.slice(start, end);
        
        if (newFeeds.length > 0) {
          setDisplayedFeeds(prev => [...prev, ...newFeeds]);
          setPage(prev => prev + 1);
          setHasMore(end < allFeeds.length);
        } else {
          setHasMore(false);
        }
      }
    }, [page, allFeeds, feedsLoading, hasMore]);

    // Add intersection observer effect
    useEffect(() => {
      if (loadingRef.current && hasMore) {
        observer.current = new IntersectionObserver(entries => {
          if (entries[0].isIntersecting && hasMore) {
            loadMoreFeeds();
          }
        }, { threshold: 0.5 });

        observer.current.observe(loadingRef.current);
      }

      return () => {
        if (observer.current) {
          observer.current.disconnect();
        }
      };
    }, [loadMoreFeeds, hasMore]);

    // Add feeds loading effect
    useEffect(() => {
      getAllFeeds()
        .then(async (response) => {
          if (response && response.data && response.data.feeds) {
            const processedFeeds = response.data.feeds.map(feed => {
              return {
                ...feed,
                feed_id: feed.feed_id || feed.id || `feed-${Math.random()}`,
                title: feed.title || feed.name || "Untitled Feed",
                date_added: feed.date_added || feed.created_at || new Date().toISOString(),
                article_id: feed.last_article_url || feed.feed_id || feed.id,
                audio_url: feed.audio_url || "https://audioread.com/share/placeholder.mp3",
              };
            });
            
            const feedsWithThumbnails = await Promise.all(
              processedFeeds.map(async (feed) => {
                try {
                  if (feed.feed_id) {
                    const latestArticle = await getLatestFeedArticle(feed.feed_id);
                    
                    if (latestArticle) {
                      return {
                        ...feed,
                        thumbnail_url: latestArticle.thumbnail_url || feed.thumbnail_url,
                        audio_url: latestArticle.audio_url,
                        article_id: latestArticle.article_id,
                        article_title: latestArticle.title,
                        article_url: latestArticle.url,
                        latestArticle: latestArticle
                      };
                    }
                  }
                  return feed;
                } catch (error) {
                  console.error(`Error fetching latest article for feed ${feed.feed_id}:`, error);
                  return feed;
                }
              })
            );
            
            setAllFeeds(feedsWithThumbnails);
            setDisplayedFeeds(feedsWithThumbnails.slice(0, FEEDS_PER_PAGE));
            setPage(1);
            setHasMore(feedsWithThumbnails.length > FEEDS_PER_PAGE);
          }
          setFeedsLoading(false);
        })
        .catch(error => {
          console.error("Error fetching feeds:", error);
          setFeedsLoading(false);
        });
    }, []);
  
    return (
      <div className="App">
        <header
          className="App-header"
          style={{
            // paddingTop: '10%',
            minHeight: '100vh'
          }}
        >
          <div className="nav-bar ">
            <div style={{ display: "flex", alignItems: "flex-start" }}>
              <div style={{ position: "relative" }}>
              <img className="audiblogs-logo" src={logo} alt="logo" />
                <ProBadge />
              </div>
              <div style={{ marginLeft: '50px' }} className="ph-badge">
                <a
                  href="https://www.producthunt.com/posts/audiblogs?utm_source=badge-top-post-badge&utm_medium=badge&utm_souce=badge-audiblogs"
                  target="_blank"
                >
                  <img
                    src="https://api.producthunt.com/widgets/embed-image/v1/top-post-badge.svg?post_id=283759&theme=dark&period=monthly"
                    alt="Audioread - Listen to any web article in your podcast player | Product Hunt"
                    style={{
                      width: '250px',
                      height: '54px',
                    }}
                    width="250"
                    height="54"
                  />
                </a>
              </div>
            </div>
  
            {/* Desktop Navigation */}
            <div className="desktop-nav" style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
              <div style={{ marginTop: '10px', display: 'flex', alignItems: 'center', gap: '20px', fontSize: '1.05rem', fontWeight: 'bold' }}>
                <Link
                    className="signin-button"
                    to="/feeds"
                    onClick={(e) => {
                      mixpanel.track('Click Feeds on Landing Page');
                      setIsMenuOpen(false);
                    }}
                  >
                    Feeds
                </Link>
                <Link
                  className="signin-button"
                  to="/freeaitexttospeech"
                  onClick={(e) => {
                    mixpanel.track('Click Free Text to Speech on Landing Page');
                    setIsMenuOpen(false);
                  }}
                >
                  Free Converter Tool
                </Link>
                <Link
                  className="signin-button"
                  to={{ pathname: "https://help.audioread.com/en/collections/12375780-use-cases" }}
                  target="_blank"
                  onClick={(e) => {
                    mixpanel.track('Click Use Cases on Landing Page');
                  }}
                >
                  Use-Cases
                </Link>
                <Link
                  className="signin-button"
                  to="/signin"
                  onClick={(e) => {
                    mixpanel.track('Click Log In on Landing Page');
                  }}
                >
                  Sign In
                </Link>
              </div>
              <div style={{display: 'flex', alignItems: 'center', transform: 'scale(0.75)', marginLeft: '-20px'}}>
                {renderSignUpButton()}
              </div>
            </div>
  
            {/* Mobile Navigation */}
            <div className="mobile-nav">
              <div style={{display: 'flex', alignItems: 'center', transform: 'scale(0.75)'}}>
                {renderSignUpButton()}
              </div>
              <button 
                onClick={toggleMenu}
                style={{
                  background: 'none',
                  border: 'none',
                  color: 'white',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                {isMenuOpen ? <CloseIcon /> : <MenuIcon />}
              </button>
              
              {/* Mobile Menu */}
              {isMenuOpen && (
                <div 
                  style={{
                    position: 'fixed',
                    top: '60px',
                    right: '20px',
                    backgroundColor: 'rgba(9, 2, 19, 0.95)',
                    padding: '20px',
                    width: '200px',
                    borderRadius: '10px',
                    backdropFilter: 'blur(10px)',
                    zIndex: 1000,
                    boxSizing: 'border-box'
                  }}
                >
                  <div style={{display: 'flex', flexDirection: 'column', gap: '15px' }}>
                    <Link
                      to="/feeds"
                      className="mobile-menu-link"
                      onClick={() => {
                        mixpanel.track('Click Feeds on Landing Page');
                        setIsMenuOpen(false);
                      }}
                    >
                      Feeds
                    </Link>
                    <Link
                      className="signin-button"
                      to="/freeaitexttospeech"
                      onClick={(e) => {
                        mixpanel.track('Click Free Text to Speech on Landing Page');
                        setIsMenuOpen(false);
                      }}
                    >
                      Free Converter Tool
                    </Link>
                    <Link
                      className="signin-button"
                      to="/signin"
                      onClick={(e) => {
                        mixpanel.track('Click Log In on Landing Page');
                        setIsMenuOpen(false);
                      }}
                    >
                      Sign In
                    </Link>
                    <Link
                      className="signin-button"
                      to={{ pathname: "https://help.audioread.com/en/collections/12375780-use-cases" }}
                      target="_blank"
                      onClick={(e) => {
                        mixpanel.track('Click Use Cases on Landing Page');
                        setIsMenuOpen(false);
                      }}
                    >
                      Use-Cases
                    </Link>
                  </div>
                </div>
              )}
            </div>
          </div>
  
          <h1 className="bigger-headline">
            Read More. Easily.
          </h1>
  
          <h2 className="subheadline">
          Use AI to listen to articles, PDFs, emails, etc. in your podcast player
          <br></br> "Read" while walking, driving, cleaning, and more
            {lanSupport && <><br></br> ✅ Supports {lanSupport}</>}
          </h2>
          {renderCta('Listen to any article')}
          <div
            className='demo-video-container'
          // style={{ margin: '10px 0' }}
          >
            <video
              className='desktop-video'
              ref={desktopVideoRef}
              autoPlay
              playsInline
              loading="lazy"
              // loop
              loop={false}
              muted
              poster={'https://audiblogs-conversions-new.s3.us-east-1.amazonaws.com/images/demo-sequence/desktop-1-540p.jpg'}
              src={`https://audiblogs-conversions-new.s3.us-east-1.amazonaws.com/images/demo-sequence/desktop-1-540p.mp4`}
              type="video/mp4"
            // style={{
            //   // height: '600px',
            //   maxWidth: '800px',
            //   borderRadius: '15px',
            //   position: "relative",
            //   right: "-150px",
            //   marginTop: "25px"
            // }}
            />
            <video
              className='mobile-video'
              loop={false}
  
              ref={mobileVideoRef}
              // autoPlay
              playsInline
              loading="lazy"
              // loop
              muted
              poster={`https://audiblogs-conversions-new.s3.us-east-1.amazonaws.com/images/demo-sequence/iphone-1-cropped.jpg`}
              src={`https://audiblogs-conversions-new.s3.us-east-1.amazonaws.com/images/demo-sequence/iphone-1-cropped.mp4`}
              type="video/mp4"
            // style={{
            //   // height: '600px',
            //   position: "relative",
            //   top: "20px",
            //   left: "-700px",
            //   height: "500px",
            //   borderRadius: "15px",
            //   boxShadow: "0px 10px 20px 0px rgba(0,0,0,0.50)"
            //   }}
            />
  
  
          </div>
  
        </header>
              
        <div
          className="App-header"
          style={{
            display: 'flex',
            flexDirection: 'column',
            margin: '0 auto',
          }}
        >
  
          <h1 className="headline" style={{ marginBottom: '0px' }}>
            "It sounds scarily good"
          </h1>
          {/* Embed YouTube Video */}
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              // flexDirection: 'column',
            }}
          >
  
            <img
              src="https://yt3.ggpht.com/ytc/AKedOLTGr4Z50rSM01ou6Ek6iCZVuAu_AZOW2v8RJfrMcw=s176-c-k-c0x00ffffff-no-rj-mo"
              style={{
                borderRadius: '100%',
                height: '50px',
                marginRight: '10px',
              }}
            ></img>
            <div style={{ fontSize: 'x-large' }}> Thomas Frank (YouTuber)</div>
          </div>
          <p class="details">
            We built an ultra-realistic text-to-speech engine that can read out loud any text. The AI voices can turn any text into audio in a natural and professional narration style. It's designed for long-form listening and trained to be indistinguishable from real audiobook narratiors. Try the demo samples below to hear for yourself.
            </p>
  
          <div style={{ width: '100%' }}>
            <div
              style={{
                marginTop: 10,
                display: 'flex',
                justifyContent: 'center',
                flexWrap: 'wrap',
                justifyContent: 'space-evenly',
  
              }}
            >
              {popularArticles.map((article) => (
                <Article
                  {...{
                    key: article.article_id,
                    article,
                    selectArticle,
                    isActive: isPlaying && currentArticle && currentArticle.article_id === article.article_id,
                    onVoiceChange: handleVoiceChange
                  }}
                />
              ))}
            </div>
            <div
              style={{
                visibility: isPlayerEnabled ? 'visible' : 'hidden',
                height: '86px',
                width: '100vw',
                position: 'fixed',
                bottom: '0',
                height: '86px',
                left: '0',
                zIndex: '9999999999999999',
              }}
            >
              <Player
                {...{
                  isFullPlayer,
                  updateIsFullPlayer,
                  currentArticle,
                  listeningWhere: '/landing',
                  autoPlay: false,
                  fullPlayerLeaveSpace: 0,
                }}
              />
            </div>
          </div>
          <div
            id="player-div"
            style={{ maxWidth: '100vw', marginTop: '50px' }}
          ></div>
        </div>
        {/* <div
          className="App-header"
          style={{
            minHeight: '85vh',
            display: 'flex',
            flexDirection: 'column',
            margin: '0 auto',
          }}
        >
          <h1 className="headline">Try Sample Articles</h1>
          
        </div> */}
        <div
          className="App-header"
          style={{
            minHeight: '85vh',
            display: 'flex',
            flexDirection: 'column',
            margin: '0 auto',
          }}
        >
  
          <div 
            className="senja-embed" 
            data-id="bb2aec3a-bbac-41bd-8915-695bd22a4720" 
            data-mode="shadow" 
            data-lazyload="false" 
            style={{ display: 'block', width: '90%', margin: '0 auto' }}
          />
        </div>
  
          <div
            className="App-header"
            style={{
              minHeight: '30vh',
              display: 'flex',
              flexDirection: 'column',
              margin: '0 auto',
            }}
          >
  
          <h1 className="headline">Convert in 2 clicks <br></br>on any device</h1>
          <div
            className="subheadline"
            style={{ marginTop: '0', marginBottom: '25px', }}
          >
            Use the web app, browser extension, iOS Shortcut, or Android app to convert text into audio.
            You can also forward emails, drag/drop PDFs, copy/paste text, or highlight text.
          </div>
          <p class="details">
            Use the web app, browser extension, iOS Shortcut, or Android app to convert text into audio. You can also forward emails, drag/drop PDFs, copy/paste text, or highlight text.
            </p>
          <div
            style={{
              display: 'flex',
              flexWrap: 'wrap',
              justifyContent: 'center',
            }}
          >
            <button
              className="transparent-button clickable"
              onClick={(e) => onClickDemo('Chrome')}
            // style={{ border: selectedDemo === 'Chrome' && '3px solid #fb1c7f' }}
            >
              <div className="content">
                <img src={Chrome} />
                <span>Browser Extension</span>
              </div>
            </button>
            <button
              className="transparent-button clickable"
              onClick={(e) => onClickDemo('Chrome')}
            // style={{ border: selectedDemo === 'Chrome' && '3px solid #fb1c7f' }}
            >
              <div className="content">
                <img src={Safari} />
                <span>Safari Shortcuts </span>
              </div>
            </button>
            <button
              className="transparent-button clickable"
              onClick={(e) => onClickDemo('iOS')}
              style={{ border: selectedDemo === 'iOS' && '3px solid #fb1c7f' }}
            >
              <div className="content">
                <AppleIcon className="icon" />
                <span>iPhone & iPad</span>
              </div>
            </button>
            <button
              className="transparent-button clickable"
              style={{
                border: selectedDemo === 'Android' && '3px solid #fb1c7f',
              }}
              onClick={(e) => onClickDemo('Android')}
            >
              <div className="content">
                <AndroidIcon className="icon"></AndroidIcon>
                <span>Android</span>
              </div>
            </button>
            <button
              className="transparent-button clickable"
              style={{
                border: selectedDemo === 'Email' && '3px solid #fb1c7f',
              }}
              onClick={(e) => onClickDemo('Email')}
            >
              <div className="content">
                <ForwardToInboxIcon className="icon"></ForwardToInboxIcon>
                <span>Forward Emails</span>
              </div>
            </button>
  
            <button
              className="transparent-button clickable"
              style={{
                border: selectedDemo === 'PDF' && '3px solid #fb1c7f',
              }}
              onClick={(e) => onClickDemo('PDF')}
            >
              <div className="content">
                <PictureAsPdfIcon className="icon"></PictureAsPdfIcon>
                <span>Drag & Drop PDFs</span>
              </div>
            </button>
            <button
              className="transparent-button clickable"
              style={{
                border: selectedDemo === 'Paste' && '3px solid #fb1c7f',
              }}
              onClick={(e) => onClickDemo('Paste')}
            >
              <div className="content">
                <ContentPasteIcon className="icon"></ContentPasteIcon>
                <span>Copy & Paste Text</span>
              </div>
            </button>
            <button
              className="transparent-button clickable"
              style={{
                border: selectedDemo === 'Highlight' && '3px solid #fb1c7f',
              }}
              onClick={(e) => onClickDemo('Highlight')}
            >
              <div className="content">
                <BorderColorIcon className="icon"></BorderColorIcon>
                <span>Highlight Text</span>
              </div>
            </button>
            <button
              className="transparent-button clickable"
              style={{
                border: selectedDemo === 'Highlight' && '3px solid #fb1c7f',
              }}
              onClick={(e) => onClickDemo('Highlight')}
            >
              <div className="content">
                <YouTubeIcon className="icon"></YouTubeIcon>
                <span>Convert YouTube</span>
              </div>
            </button>
  
  
          </div>
          {/* <div style={{ margin: '10px 0' }}>
            <video
              id="demo-video"
              autoPlay
              playsInline
              loop
              muted
              src={demoUrl}
              type="video/mp4"
              style={{
                maxHeight: '60vh',
                maxWidth: '100vw',
              }}
            />
          </div> */}
        </div>
        <div
          className="App-header"
          style={{
            display: 'flex',
          }}
        >
          <h1 className="headline">
            Listen in <br></br> any podcast app
          </h1>
          <h2 className="subheadline">
  
            Create and subscribe to your own podcast that only you subscribe to.
          </h2>
          <p class="details">
            We generate a private podcast RSS feed. You can subscribe to it in any podcast app, so you can listen to articles, PDFs, emails, and other text in Apple Podcasts, Google Podcasts, Spotify, and others. This is perfect for podcast lovers and busy professionals who want to increase their productcitivy, multi-task, and learn on the go.
            </p>
  
  
          <div>
            <div className="podcast-apps">
              {PodcastApp(applepodcasts, 'Apple Podcasts')}
              {PodcastApp(spotify, 'Spotify')}
              {PodcastApp(googlepodcasts, 'Google Podcasts')}
              {PodcastApp(overcast, 'Overcast')}
              {PodcastApp(pocketcasts, 'Pocket Casts')}
              {PodcastApp(podcastAddict, 'Podcast Addict')}
              {PodcastApp(castbox, 'Castbox')}
              {PodcastApp(castro, 'Castro')}
              {PodcastApp(thePodcastApp, 'The Podcast App')}
              {PodcastApp(downcast, 'Downcast')}
              {PodcastApp(podbean, 'Podbean')}
              {PodcastApp(breaker, 'Breaker')}
              {PodcastApp(podcastRepublic, 'Podcast Republic')}
              {PodcastApp(playerfm, 'Player FM')}
              {PodcastApp(radiopublic, 'Radio Republic')}
              {PodcastApp(airr, 'Airr')}
            </div>
            <div style={{ fontSize: '2em', margin: '10px' }}>And More!</div>
          </div>
        </div>
  
        <div
          className="App-header"
          id="tweets"
          style={{
            minHeight: '85vh',
            display: 'flex',
            flexDirection: 'column',
            margin: '0auto',
          }}
        >
          <h1 className="headline">
            Or listen in the browser
            <br></br>
            (No installation required)
          </h1>
          <div className="subheadline">
  
            Don't use a podcast app? No problem.
          </div>
  
          <p class="details">
            Using the web app, you can instantly convert any text to audio, listen to it, and download MP3 files online. This is perfect for people who want to listen to articles, PDFs, emails, and other text on their computer or phone without using a podcast app.
          </p>
          <p class="details">
            You can insatll the browser extension on Chrome, Edge, Brave, and other Chromium-based browsers to convert in two clicks. The extension allows you to save web articles to listen later, highlight text to convert, upload PDFs, and more.
          </p>
          <p class="details">
            Using Safari Shortcuts, you can convert any web articles to audio on macOS, iPadOS, and iOS while browsing in Safari. You'll simply add Apple's native Shortcuts app, and a new action will show up in the Share menu in Safari. This is perfect for those who mainly browse in Safari on Mac or iPhone. 
          </p>
  
          <p class="details">
            If you use Android, you can install the PWA (Progressive Web App). Then, Audioread will show up to convert any text to audio in your browser. This is perfect for those who mainly browse in Chrome on Android.
          </p>
  
  
          <div
            style={{
              display: 'flex',
              flexWrap: 'wrap',
              maxWidth: '100vw',
              justifyContent: 'center',
              overflow: 'hidden',
            }}
          >
            <img className="screenshot" src={screenshot}></img>
          </div>
        </div>
        {/* <div
          className="App-header"
          id="tweets"
          style={{
            minHeight: '85vh',
            display: 'flex',
            flexDirection: 'column',
            margin: '0auto',
          }}
        >
          <h1 className="headline">
            Detailed Walkthrough Video
          </h1>
  
          <YoutubeIframe videoId={"MVcS_jpdJPk"} videoTitle={"Audioread Walkthrough"} />
  
        </div> */}
        <div className="App-header" id="tweets" style={{ minHeight: '85vh' }}>
          <h1 className="headline">
            Pricing
          </h1>

          <div style={{ display: 'flex', flexWrap: 'wrap', maxWidth: '100vw', width: '100%', justifyContent: 'center', padding: '0 20px' }}>
            <div
              className="pricing-card"
              style={{
                marginTop: '15px',
                width: '100%',
                maxWidth: '800px',
                border: "2px solid hsla(0,0%,100%,.1)",
                padding: '20px',
                minHeight: 'fit-content',
                display: 'flex',
                flexDirection: 'column'
              }}
            >
              <div style={{ display: 'flex', justifyContent: 'center', gap: '20px', margin: '20px 0' }}>
                <div 
                  onClick={() => setIsYearly(false)}
                  style={{
                    padding: '8px 20px',
                    border: '2px solid hsla(0,0%,100%,.1)',
                    borderRadius: '20px',
                    cursor: 'pointer',
                    backgroundColor: !isYearly ? 'rgba(255,255,255,0.1)' : 'transparent',
                    transition: 'background-color 0.2s ease'
                  }}
                >
                  Monthly
                </div>
  
                <div
                  onClick={() => setIsYearly(true)}
                  style={{
                    padding: '8px 20px', 
                    border: '2px solid hsla(0,0%,100%,.1)',
                    borderRadius: '20px',
                    cursor: 'pointer',
                    backgroundColor: isYearly ? 'rgba(255,255,255,0.1)' : 'transparent',
                    transition: 'background-color 0.2s ease'
                  }}
                >
                  Yearly <span style={{ color: '#4CAF50' }}>(Save 17%)</span>
                </div>
              </div>
  
              <div style={{ 
                display: 'flex', 
                justifyContent: 'center', 
                gap: '20px', 
                margin: '40px 0', 
                flexWrap: 'wrap'
              }}>
                <div
                  style={{
                    padding: '30px',
                    border: '2px solid hsla(0,0%,100%,.1)',
                    borderRadius: '8px',
                    flex: '1 1 300px',
                    maxWidth: '350px',
                    cursor: 'pointer',
                    backgroundColor: 'rgba(255,255,255,0.1)',
                    margin: '0 0 20px 0'
                  }}
                >
                  <div style={{ fontSize: '24px', fontWeight: 'bold', marginBottom: '10px' }}>Unlimited Basic</div>
                  <div style={{ fontSize: '32px', fontWeight: 'bold', color: 'rgb(255 143 65)' }}>${isYearly ? '4.16' : '4.99'}</div>
                  <div style={{ opacity: 0.8 }}>per month</div>
                  {isYearly && <div style={{ fontSize: '14px', opacity: 0.8 }}>Billed annually at $49.99</div>}
                  <ul style={{ textAlign: 'left', marginTop: '25px', paddingLeft: '20px' }}>
                    <li>Unlimited articles</li>
                    <li>Life-like voices</li>
                    <li>Listen on your podcast player</li>
                    <li>Automated content creation</li>
                    <li>Unlimited Feeds</li>
                    <li>Add urls, pdfs, and more</li>
                  </ul>
                </div>
  
                <div
                  style={{
                    padding: '30px',
                    border: '2px solid hsla(0,0%,100%,.1)',
                    borderRadius: '8px',
                    flex: '1 1 300px',
                    maxWidth: '350px',
                    backgroundColor: 'rgba(255,255,255,0.1)',
                    margin: '0 0 20px 0'
                  }}
                >
                  <div style={{ fontSize: '24px', fontWeight: 'bold', marginBottom: '10px' }}>Unlimited Pro</div>
                  <div style={{ fontSize: '32px', fontWeight: 'bold', color: 'rgb(255 143 65)' }}>${isYearly ? '8.33' : '9.99'}</div>
                  <div style={{ opacity: 0.8 }}>per month</div>
                  {isYearly && <div style={{ fontSize: '14px', opacity: 0.8 }}>Billed annually at $99.99</div>}
                  <ul style={{ textAlign: 'left', marginTop: '25px', paddingLeft: '20px' }}>
                    <li>Everything in Basic</li>
                    <li>Premium voices</li>
                    <li>Multi-language support</li>
                    <li>AI Summaries</li>
                    <li>Unlimited Feeds</li>
                    <li>More advanced features</li>
                  </ul>
                </div>
              </div>
  
              <div style={{ textAlign: 'center', marginTop: '20px', marginBottom: '20px' }}>
                {renderCta('pricing')}
              </div>
  
            </div>
          </div>
        </div>

        {/* Popular Feeds Section */}
        <div className="App-header" style={{ minHeight: '85vh' }}>
          <h1 className="headline">
            Popular Feeds
          </h1>
          <div className="article-container" style={{ 
            marginTop: "50px", 
            marginBottom: "50px",
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, 300px)",
            gap: "20px",
            paddingRight: "30px",
            width: "100%",
            maxWidth: "1200px",
            margin: "50px auto",
            justifyContent: "center"
          }}>
            {feedsLoading ? (
              <div className="feeds-loading-container" style={{ 
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%',
                padding: '100px 20px',
                gap: '20px',
                gridColumn: "1 / -1"
              }}>
                <CircularProgress 
                  size={40} 
                  sx={{
                    color: '#4292fa',
                    '@keyframes gradient': {
                      '0%': { color: '#4292fa' },
                      '25%': { color: '#8535cd' },
                      '50%': { color: '#e82186' },
                      '75%': { color: '#ff5c57' },
                      '100%': { color: '#4292fa' }
                    },
                    animation: 'gradient 2s ease infinite'
                  }}
                />
                <p style={{ 
                  color: '#fff',
                  fontSize: '16px',
                  fontWeight: 500,
                  background: 'linear-gradient(90deg, #4292fa, #8535cd, #e82186, #ff5c57)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  backgroundSize: '300% 100%',
                  animation: 'gradient 2s ease infinite'
                }}>Loading feeds...</p>
              </div>
            ) : (
              <>
                {displayedFeeds.slice(0, 9).map((feed) => (
                  <Link 
                    key={feed.feed_id || feed.id || Math.random().toString()}
                    to="/signin"
                    style={{
                      textDecoration: 'none',
                      color: 'inherit',
                      cursor: 'pointer',
                      transition: 'transform 0.2s ease',
                      display: 'block',
                      width: '100%'
                    }}
                    className="feed-link"
                  >
                    <FeedSubscribed
                      feed={feed}
                      idToken={null}
                      selectArticle={() => {}}
                      isActive={false}
                      onUnsubscribe={() => {}}
                      isSubscribed={false}
                    />
                  </Link>
                ))}
              </>
            )}
          </div>
        </div>

        <div className="App-header">
          <h1 className="headline">
            Don't have time to read?
          </h1>
          <h2 className="subheadline">Start audioreading! Do more with your time. <br></br></h2>
          {renderCta('No one has time to read')}
        </div>
        <OneGiftLogo />
        <div className="footer-links" style={{ margin: '25px', display: 'flex', gap: '20px', justifyContent: 'center' }}>
          <Link to="/terms">Terms of Service</Link>
          <Link to="/privacy">Privacy Policy</Link>
          <Link to="/dmca">DMCA Policy</Link>
          <a href="https://audioread.tolt.io/" target="_blank" rel="noopener noreferrer">Affiliate Program</a>
        </div>
        <div style={{ margin: '25px', opacity: 0.7 }}>© {new Date().getFullYear()} Audioread™. All rights reserved.</div>
      </div>
    );
  });

export default LandingA; 